import * as React from "react"
const StreetLight = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    className="icon"
    transform="rotate(-45)"
    viewBox="0 0 1024 1024"
    {...props}
  >
    <path fill="#0071CE" d="M481.7 374.7h61.9v531.7h-61.9z" />
    <path fill="#00B3E3" d="M481.7 753.6h61.9v152.8h-61.9z" />
    <path d="M481.7 374.7h61.9v65.1h-61.9z" />
    <path
      fill="#2B3E49"
      d="M589.9 922.2v-18.1c0-9.6-7.8-17.4-17.4-17.4H452.8c-9.6 0-17.4 7.8-17.4 17.4v18.1h154.5z"
    />
    <path
      fill="#A4A9AD"
      d="M620.9 171.7c0-59.8-48.5-108.3-108.3-108.3s-108.3 48.5-108.3 108.3h216.6z"
    />
    <path d="M620.9 171.7c0-21-6-40.5-16.3-57.1h-184c-10.3 16.6-16.3 36.1-16.3 57.1h216.6z" />
    <path fill="#F2D383" d="M620.9 158.1H404.4l34.2 216.6h148.1z" />
    <path
      fill="#333E48"
      d="M603.8 280.9H421.5c-8 0-14.5-6.5-14.5-14.5s6.5-14.5 14.5-14.5h182.3c8 0 14.5 6.5 14.5 14.5s-6.5 14.5-14.5 14.5zm17.1-91.9H404.4c-17 0-30.8-13.8-30.8-30.8s13.8-30.8 30.8-30.8H621c17 0 30.8 13.8 30.8 30.8 0 16.9-13.8 30.8-30.9 30.8zm-34.2 216.6h-148c-17 0-30.8-13.8-30.8-30.8s13.8-30.8 30.8-30.8h148c17 0 30.8 13.8 30.8 30.8s-13.8 30.8-30.8 30.8z"
    />
    <path
      fill="#A4A9AD"
      d="M615.9 960.3c4.9 0 9-4 9-9V945c0-14-11.3-25.3-25.3-25.3H425.8c-14 0-25.3 11.3-25.3 25.3v6.3c0 4.9 4 9 9 9h206.4z"
    />
    <path
      fill="#FFB819"
      d="M284.7 349.4c-6 0-11.5-3.7-13.6-9.7-2.7-7.5 1.3-15.8 8.8-18.4l69.6-24.5c7.5-2.7 15.8 1.3 18.4 8.8 2.7 7.5-1.3 15.8-8.8 18.4l-69.6 24.5c-1.5.7-3.2.9-4.8.9zm69.7-103.7c-.6 0-1.2 0-1.9-.1L262.3 234c-7.9-1-13.5-8.3-12.5-16.2 1-7.9 8.3-13.5 16.2-12.5l90.2 11.6c7.9 1 13.5 8.3 12.5 16.2-.9 7.3-7.2 12.6-14.3 12.6zm386.2 103.7c-1.6 0-3.2-.3-4.8-.8l-69.6-24.5c-7.5-2.7-11.5-10.9-8.8-18.4 2.7-7.5 10.9-11.5 18.4-8.8l69.6 24.5c7.5 2.7 11.5 10.9 8.8 18.4-2.1 5.9-7.7 9.6-13.6 9.6zm-69.7-103.7c-7.2 0-13.4-5.3-14.3-12.6-1-7.9 4.6-15.2 12.5-16.2l90.2-11.6c7.9-1 15.2 4.6 16.2 12.5S770.9 233 763 234l-90.2 11.6c-.6.1-1.2.1-1.9.1z"
    />
  </svg>
)
export default StreetLight
